import React from "react";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import Table from "../../Common/Table";
import TableFields from "../../../constants/DeliveryDrivers/TableFields.json";
import DeliveryPartnerBlankState from "../DeliveryPartnerBlankState";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import { isValNull } from "../../../utils";

const PartnersListTable = ({ list = [], resetIndividualDriverState }) => {
  const history = useHistory();
  const getFieldValue = (item, key) => {
    switch (key) {
      case "name":
        return (
          <span onClick={() => handleRowClick(item)} className="edit-options">
            {item[key]}
          </span>
        );
      case "locality_name":
        return (
          <span
            onClick={() => handleLocalityClick(item["locality_id"])}
            className="edit-options"
          >
            {item[key]}
          </span>
        );
      case "city_name":
        return (
          <span
            onClick={() => handleCityClick(item["city_id"])}
            className="edit-options"
          >
            {item[key]}
          </span>
        );
      default:
        return item[key];
    }
  };

  const handleCityClick = (city_id) => {
    if (!isValNull(city_id)) {
      window.open(window.location.origin + `/cities/${city_id}`, "_blank");
    }
  };

  const handleLocalityClick = (locality_id) => {
    if (!isValNull(locality_id)) {
      window.open(
        window.location.origin + `/localities/${locality_id}`,
        "_blank"
      );
    }
  };

  const handleRowClick = (item) => {
    resetIndividualDriverState();
    history.push(`/delivery-drivers/${item.driver_id}/details`);
  };

  return (
    <PartnersListTableContainer>
      {list.length > 0 ? (
        <Table
          fontSize="0.75rem"
          list={list}
          fields={TableFields}
          getFieldValue={getFieldValue}
        />
      ) : (
        <DeliveryPartnerBlankState />
      )}
    </PartnersListTableContainer>
  );
};

const PartnersListTableContainer = styled.div`
  background: ${variables.white};
  border: 0.5px solid ${variables.grey300};
  box-sizing: border-box;
  border-radius: 8px;
  height: 100%;
`;

function mapDispatchToProps(dispatch) {
  return {
    resetIndividualDriverState: bindActionCreators(
      DeliveryDriversActions.resetIndividualDriverState,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(PartnersListTable);
